// extracted by mini-css-extract-plugin
export default {"submitBtn":"Itj5QcYYyhCJneuK8SdY"};